module.exports = __webpack_public_path__ + "static/img/Logo_PROF_XXI.55fcad1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo_PROF_XXI.png
// module id = W5lA
// module chunks = 1